import React, { useState, useEffect } from "react";

import { Select } from "@rocketseat/unform";

/**
 * Props:
 * data - Opções do select
 * changefn - Funnção para ser executada ao trocar o valor do select
 * label - Título do select
 * name - Nome do select
 */
export default function Vermelho({ data, changefn, label, name }) {
  const [options, setOptions] = useState([{ id: 0, title: "Selecione" }]);

  useEffect(() => {
    let options = [{ id: 0, title: "Selecione" }];

    data.map(value => options.push(value));

    setOptions(options);
  }, []);

  /** Chama a função passada pelo componenete pai */
  function handleChange(event) {
    if (changefn) changefn(event);
  }

  return (
    <div className="d-flex">
      <label className="big">{label}</label>
      <div className="filtro__input_container">
        <Select
          className="ant-input"
          name="devolucao"
          options={options}
          onChange={handleChange}
          name={name}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Filtro/components/Vermelho/DevolucaoField.js